module.exports = __webpack_public_path__ + "img/pic_330626.0cdc59b0.jpg";